import { useReactiveVar } from '@apollo/client/react';
import { AvatarList, UserAvatar } from '@pocketlaw/tetris';
import { documentUsers, usePreview } from 'shared/domains/documents';
export function ActiveUsers() {
    const { isRtcAvailable } = usePreview();
    const users = useReactiveVar(documentUsers);
    if (!isRtcAvailable || !users.length) {
        return null;
    }
    const uniqueUsers = Array.from(new Set(users));
    const sortedUsers = uniqueUsers.sort((user) => (user.isMe ? -1 : 1));
    return (<AvatarList size="xs">
      {sortedUsers.map((user) => (<UserAvatar key={user.id} title={user.name}/>))}
    </AvatarList>);
}
